import styles from './Features.module.scss'

interface Props {
  contents: {
    title: string
    items: {
      num: string
      itemTitle: string
      description: string
      src: string
    }[]
  }
}

const Features: React.FC<Props> = ({ contents }) => {
  const listItems = contents.items.map((item, i) => (
    <li key={i}>
      <div className={styles.feature_image_wrapper}>
        <img src={item.src} alt="" className={styles.feature_image} />
      </div>
      <div className={styles.feature_item}>
        <p className={styles.feature_number}>Feature {item.num}</p>
        <div className={styles.feature_title}>{item.itemTitle}</div>
        <p className={styles.feature_description}>{item.description}</p>
      </div>
    </li>
  ))
  return (
    <div className={styles.features_section}>
      <div className={styles.wrapper}>
        <div className={styles.section_heading}>
          <span>{contents.title}</span>導入支援の3つの特徴
        </div>
      </div>
      <ul className={styles.feature_wrapper}>{listItems}</ul>
    </div>
  )
}
export default Features
